import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearCashAppOrder, clearChimeOrder} from '../../../../reducers/app/actions';

export default ({order}) => {
    const navigate = useNavigate(),
          dispatch = useDispatch();

    if(!order)
        return <PageLoader />;

    return (
        <>
            <div className="alert">
                <div className="icon">
                    ✅
                </div>

                <div className="mt10"></div>
                <div className="title">Chime</div>
                <div className="text">Your request for a <b>${order.amount}</b> deposit is being processed! If you did everything correctly, it will take 1 minute.</div>
            
                <div className="mt40"></div>

                <div className="big-text">Unique Payment ID: <span className="text-green">{order.paymentId}</span></div>
            </div>

            <div className="button" onClick={e => {
                dispatch(clearChimeOrder());
                navigate('/');
            }}>Okay, thanks!</div>
        </>
    )
}